import {createAction} from 'redux-act'

export const handleCreateJob = createAction<string | number>('HANDLE_CREATE_JOB')
export const handleUpdateJob = createAction<string | number>('HANDLE_UPDATE_JOB')
export const handleRemoveJob = createAction<string | number>('HANDLE_REMOVE_JOB')
